/**
 * Overrides de vocabulario para organizaciones de tipo "cliente".
 *
 * El sistema es el mismo para condominios y clientes; lo único que cambia es el
 * vocabulario que ve el usuario. Estos overrides se fusionan (deep-merge) sobre
 * la traducción base cuando el tenant activo es de tipo 'cliente', de modo que
 * TODOS los `t('...')` existentes resuelvan al vocabulario de cliente sin tener
 * que tocar cada componente.
 *
 * Solo se incluyen las llaves cuyo texto menciona condominio / residente /
 * filial / propietario. El resto se hereda de la traducción base.
 *
 * Se aplica desde applyTenantVocab() en useTenantTipo.js.
 */

export const clienteOverrides = {
  es: {
    sidebar: {
      residentes: "Clientes",
    },
    common: {
      filial: "Cliente",
      condominio: "Organización",
    },
    dashboard: {
      filialesRegistradas: "Clientes registrados",
      propietarios: "cliente(s)",
      filialesConSaldo: "cliente(s) con saldo pendiente",
      filiales: "clientes",
      residentesLink: "Clientes",
    },
    residentes: {
      titulo: "Clientes",
      agregarResidente: "Agregar Cliente",
      listaResidentes: "Lista de Clientes",
      filial: "Cliente",
      propietario: "Cliente",
      buscarResidente: "Buscar cliente...",
      sinResidentes: "No hay clientes registrados",
    },
    facturas: {
      filial: "Cliente",
      colPropietario: "Cliente",
      buscarPlaceholder: "Buscar por factura, cliente o concepto…",
    },
    invoices: {
      filial: "Cliente",
      sinFiliales: "No hay clientes. Agregá un cliente primero.",
      propietario: "Cliente",
    },
    recibos: {
      buscarPlaceholder: "Buscar por recibo, cliente o referencia…",
      estadoCuentaDesc: "Genera el estado financiero por cliente en PDF",
    },
    emails: {
      emailPropietario: "Se enviará al email principal de cada cliente",
      sinEmailWarning: "Si un cliente no tiene email principal registrado, esa factura aparecerá como error en el resultado.",
      filialLabel: "Cliente {{id}}",
      emailPropietarioRecibo: "Con PDF adjunto al email principal del cliente",
    },
    cxc: {
      administra: "Estado de deuda por cliente",
      filialesConSaldo: "Clientes con saldo pendiente",
      buscarPlaceholder: "Buscar cliente…",
      sinFiliales: "No hay clientes con el filtro seleccionado.",
      filiales: "cliente(s)",
      propietario: "Cliente",
    },
    cxp: {
      administra: "Estado de deuda por proveedor de la organización",
      administraFacturas: "Administra los documentos emitidos por proveedores a la organización",
    },
    presupuesto: {
      administra: "Administra el presupuesto de tu organización.",
    },
    settings: {
      condominio: "Organización",
    },
    masiva: {
      filialesLabel: "Clientes",
      buscarFilial: "Buscar cliente…",
      cargandoFiliales: "Cargando clientes…",
      errFiliales: "Seleccioná al menos un cliente",
    },
  },
  en: {
    sidebar: {
      residentes: "Clients",
    },
    common: {
      filial: "Client",
      condominio: "Organization",
    },
    dashboard: {
      filialesRegistradas: "Registered clients",
      propietarios: "client(s)",
      filialesConSaldo: "client(s) with pending balance",
      filiales: "clients",
      residentesLink: "Clients",
    },
    residentes: {
      titulo: "Clients",
      agregarResidente: "Add Client",
      listaResidentes: "Client List",
      filial: "Client",
      propietario: "Client",
      buscarResidente: "Search client...",
      sinResidentes: "No clients registered",
    },
    facturas: {
      filial: "Client",
      colPropietario: "Client",
      buscarPlaceholder: "Search by invoice, client or concept…",
    },
    invoices: {
      filial: "Client",
      sinFiliales: "No clients. Add a client first.",
      propietario: "Client",
    },
    recibos: {
      buscarPlaceholder: "Search by receipt, client or reference…",
      estadoCuentaDesc: "Generates the financial statement per client in PDF",
    },
    emails: {
      emailPropietario: "It will be sent to each client's primary email",
      sinEmailWarning: "If a client has no primary email registered, that invoice will appear as an error in the result.",
      filialLabel: "Client {{id}}",
      emailPropietarioRecibo: "With PDF attached to the client's primary email",
    },
    cxc: {
      administra: "Debt status per client",
      filialesConSaldo: "Clients with pending balance",
      buscarPlaceholder: "Search client…",
      sinFiliales: "No clients with the selected filter.",
      filiales: "client(s)",
      propietario: "Client",
    },
    cxp: {
      administra: "Debt status per supplier of the organization",
      administraFacturas: "Manage documents issued by suppliers to the organization",
    },
    presupuesto: {
      administra: "Manage your organization's budget.",
    },
    settings: {
      condominio: "Organization",
    },
    masiva: {
      filialesLabel: "Clients",
      buscarFilial: "Search client…",
      cargandoFiliales: "Loading clients…",
      errFiliales: "Select at least one client",
    },
  },
};
